import "../../styles/screens/services.scss";
import checkIcon from "../../assets/images/Icons/checkIcon.png";
import checkImg from "../../assets/images/Images/checkImg.png";
import AOS from "aos";
import "aos/dist/aos.css";
import de from "../../assets/texts/de.json";
import sr from "../../assets/texts/sr.json";
import { useLanguage } from "../../i18n/LanguageContext";

const ServiceThird = () => {
  AOS.init({ duration: 2000 });
  const { language } = useLanguage();
  const t = language === "sr" ? sr.servicePages.third : de.servicePages.third;
  return (
    <div className="service-third">
      <div className="service-title" data-aos="fade-down">
        <h1 className="title">{t.title}</h1>
        <img className="magnifier" src={checkIcon} alt="Magnifier"></img>
      </div>
      <div className="divider"></div>
      <div className="content">
        <ul className="points">
          <li
            className="subtitle-first"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="100"
          >
            {t.sections[0].title}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="400"
          >
            {t.sections[0].text}
          </li>
          <li
            className="subtitle-second"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="700"
          >
            {t.sections[1].title}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1000"
          >
            {t.sections[1].text}
          </li>
          <li
            className="subtitle-third"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1300"
          >
            {t.sections[2].title}
          </li>
          <li
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-back"
            data-aos-delay="1600"
          >
            {t.sections[2].text}
          </li>
        </ul>
        <div className="image-container">
          <img src={checkImg} alt="Mystery Check" />
        </div>
      </div>
    </div>
  );
};

export default ServiceThird;
